import React from 'react'
import {useDispatch,useSelector} from 'react-redux'
import Modal from 'react-bootstrap/Modal'
import {fullBasePath} from '../../../util/util'
import {updatePreview} from '../../../state/events'

/**
 * Since many deeply nested components need to control the state 
 * of this component we'll use redux
 */
const PreviewModal = ()=>{
	const dispatch = useDispatch()
	const {show,exercise} = useSelector(state=>state.allEvents.preview)

	const handleClose = ()=>{
		dispatch(updatePreview({show:false}))
	}
	if(!exercise) return null
	return (
		<Modal show={show} onHide={handleClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>{exercise.name}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<img src={`${exercise.preview_src}`} style={{width:'100%'}}/>
			</Modal.Body>
		</Modal>
	)
}

export default PreviewModal